<div class="flex items-center justify-center min-h-screen">
  <div *ngIf="dialogData.device as device" class="flex-flex-col items-center w-full max-w-2xl">
    <section class="flex justify-end">
      <ui-close [border]="true" (click)="dialogRef.close()"></ui-close>
    </section>

    <section>
      <div class="flex gap-4 items-center mb-6">
        <img [src]="deviceImage" [attr.alt]="device.name" class="h-9 max-w-[36px]" />
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center gap-2">
            <h3>{{ device.name }}</h3>
            <span>
              <img
                *ngIf="device.device_properties.online"
                src="assets/iconography/online-antenna.svg"
                class="device-status-icon"
                alt="online" />
              <img
                *ngIf="!device.device_properties.online"
                src="assets/iconography/offline-antenna.svg"
                class="device-status-icon"
                alt="offline"
                [matTooltip]="device.issues | deviceIssuesTooltip" />
            </span>
          </div>
          <span *ngIf="dialogData.currentNumber" class="text-sm">
            {{ dialogData.currentNumber | titlecase }}
          </span>
        </div>
      </div>

      <sbnb-property-selection
        title="Match device to the properties where it's installed"
        [selectedProperties]="properties"
        [allPropertiesEnabled]="false"
        [border]="true"
        [listHeight]="280"
        (propertiesChange)="setLockProperties($event)"
        (newPropertyChecked)="newPropertyChecked($event)"></sbnb-property-selection>

      <section class="border rounded border-smoke p-4 mt-4" *ngIf="device.device_type === 'lock'">
        <h3 class="mb-2">Settings</h3>

        <div class="flex gap-3 items-center mb-2">
          <span class="text-sm block w-40">PIN code length</span>

          <mat-form-field class="nopadding input__mini w-20">
            <input
              matInput
              class="nopadding"
              name="pinCode"
              type="number"
              [min]="device.min_length"
              [max]="device.max_length"
              [(ngModel)]="device.code_length"
              required />
          </mat-form-field>
        </div>

        <div class="flex gap-3 items-center">
          <span class="text-sm block w-40">Low Battery Threshold</span>
          <mat-form-field class="input__mini nopadding threshold-input w-20">
            <input
              matInput
              name="batteryThreshold"
              [(ngModel)]="dialogData.device.device_properties.battery.threshold"
              type="number"
              min="0"
              max="99"
              required />
            <span matSuffix>%</span>
          </mat-form-field>
        </div>

        <ng-container>
          <div class="mt-2">
            <span class="text-sm inline-block w-40 mr-1">Guest access?</span>
            <mat-checkbox [(ngModel)]="dialogData.device.guest_access"></mat-checkbox>
          </div>
          <span class="text-night-lighter text-sm">
            Disable if guests should not access this lock. For example, a lock on a cleaning closet.
          </span>
        </ng-container>
      </section>

      <div class="flex justify-end gap-4 mt-8 mb-12">
        <sbnb-button
          *ngIf="existingProperties.length === 0"
          label="Don't match this {{ dialogData.device.device_type }}"
          type="secondary"
          (click)="dialogRef.close()"></sbnb-button>
        <sbnb-button
          label="Save"
          [disabled]="validating || !isBatteryThresholdValid()"
          [loading]="saving"
          (clicked)="onSaveClicked()"></sbnb-button>
      </div>
    </section>
  </div>
</div>
